import React from 'react';
import { motion } from 'framer-motion';
import { ShieldIcon } from './Icons';
export function GuaranteeSection() {
  return <section className="bg-parchment py-24 px-4" data-id="element-144">
      <div className="max-w-3xl mx-auto" data-id="element-145">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="border-4 border-gold/30 bg-white p-8 md:p-12 rounded-2xl text-center relative" data-id="element-146">
          <div className="absolute -top-8 left-1/2 -translate-x-1/2 bg-parchment px-4" data-id="element-147">
            <div className="bg-gold text-dark p-4 rounded-full shadow-lg" data-id="element-148">
              <ShieldIcon className="w-8 h-8" data-id="element-149" />
            </div>
          </div>

          <h2 className="text-2xl md:text-4xl font-serif font-bold text-dark mt-8 mb-6" data-id="element-150">
            La Garantía "Encuentro Real"
          </h2>
          <h3 className="text-xl font-bold text-olive mb-8" data-id="element-151">
            7 Días de Garantía Total — Sin Preguntas Incómodas
          </h3>

          <div className="space-y-6 text-lg text-dark/80" data-id="element-152">
            <p data-id="element-153">
              Si en los próximos 7 días no experimentas una paz mayor, una
              claridad nueva al leer las Escrituras, o simplemente sientes que
              este protocolo no es para ti...
            </p>
            <p className="font-bold text-dark" data-id="element-154">
              Envíanos un correo y te devolvemos cada centavo.
            </p>
            <p data-id="element-155">Sin preguntas. Sin formularios complicados. Sin burocracia.</p>
            <p className="text-xl font-serif italic text-gold-dark mt-8" data-id="element-156">
              "El riesgo es completamente mío. La transformación es
              completamente tuya."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}